// A finding without a single time entry belongs to the employee summary.
// Never guess a punch from the date or name: split shifts can share both.
export function getActualComplianceWarnings(data, cards) {
  const byEntry = {};
  const byEmployee = {};
  const visibleEntryIds = new Set((cards || []).flatMap((card) =>
    card.is_missed || card.in_progress ? [] : (card.platform_time_entry_keys || []).map(String)
  ));
  (data?.groups || []).forEach((group) => {
    group.violations.forEach((violation) => {
      const detail = violation.violation_detail || group.regulation_type_name;
      const entryId = violation.platform_time_entry_key;
      if (entryId != null && visibleEntryIds.has(String(entryId))) {
        (byEntry[entryId] ||= []).push(detail);
      } else if (violation.store_team_member_id != null) {
        // Includes weekly rules and findings whose punch is outside this
        // displayed week, so they stay discoverable on the employee row.
        (byEmployee[violation.store_team_member_id] ||= []).push(detail);
      }
    });
  });
  return { byEntry, byEmployee };
}

export function getActualShiftWarnings(shift, byEntry) {
  if (!shift?.is_actual_card || shift.is_missed || shift.in_progress) return [];
  return [...new Set((shift.platform_time_entry_keys || []).flatMap((id) => byEntry?.[id] || []))];
}

// A weekly card can stack several actual punches from the same day.
export function getActualCardWarnings(shifts, byEntry) {
  return [...new Set((shifts || []).flatMap((shift) => getActualShiftWarnings(shift, byEntry)))];
}
